if (!window.cip_Common) {
	window.cip_Common = {};
}

(function () {
	"use strict";
	
	cip_Common.COOKIE_DEVICE_FINGERPRINT = "cip_device_fingerprint";
	cip_Common.COOKIE_DEVICE_FINGERPRINTED = "cip_device_fingerprinted";
	cip_Common.keepAliveInterval = 1000 * 60 * 15; // 15 mins

	cip_Common.init = function(callback){
		cc_Config.parameters = cc_Util.getUrlVars();
		
		var urlSegments = document.location.href.split("/");
			
		var segmentIndex = 4;
		cip_Common.isApplicationUrl = urlSegments.length == 9;
		cip_Common.isStatusUrl = urlSegments.length == 8;
		
		cip_Common.siteId = urlSegments[segmentIndex++];
		cip_Common.environment = urlSegments[segmentIndex++];
		cip_Common.brandId = urlSegments[segmentIndex++];
		
		cc_Config.siteId = cip_Common.siteId; // required by the cc_ExternalWidgetPlugin
		cc_Config.environment = cip_Common.environment; // required by the cc_ExternalWidgetPlugin
		cc_Config.entityName = cip_Common.brandId; // required by the cc_ExternalWidgetPlugin
		
		if(cip_Common.isApplicationUrl){
			cip_Common.formId = urlSegments[segmentIndex++];
		}
		
		cip_Common.page = urlSegments[segmentIndex].substring(0, urlSegments[segmentIndex].indexOf('.'));
		
		var doCallback = function(){
			if(cip_Entity){
				cip_Entity.init();
			}
			
			if(callback){
				callback();
			} 
		}
		
		cip_Common.initDeviceFingerprint(function(){
			doCallback();
		});
	};
	
	cip_Common.initDeviceFingerprint = function(successCallback){
		
		// has the device fingerprint been set
		if($.cookie(cip_Common.COOKIE_DEVICE_FINGERPRINTED) === null){
			// give the page a little time to initialise when creating the device fingerprint
			$.doTimeout(500, function(){
				
				// add a browser fingerprint cookie
				$.cookie(cip_Common.COOKIE_DEVICE_FINGERPRINT, cc_UI.getDeviceFingerprint(), {
					path : "/" + cip_Common.getContextPath(), 
					secure : cip_Common.isUsingHttps()
				});
				
				// inform the server of the new fingerprint
				$.ajax({ 
					url: cip_Common.toRootUrl() + '/init/device/fingerprint',
					type: 'POST',
					handle: function (response) { 
						if(response.unexpectedOutcome){
							cip_Common.handleUnexpectedOutcome(response);
						}else{
							successCallback();
						}
					}
				});
				
			});
		}else{
			// device fingerprint cookie exists
			successCallback();
		}
	};
	
	cip_Common.authenticate = function(nonce, successCallback){
		$.ajax({ 
			url: cip_Common.toAuthenticationUrl() + '/authenticate',
			type: 'POST',
			data: {
				nonce : nonce
			},
			handle: function (response) { 
				if(response.unexpectedOutcome){
					cip_Common.handleUnexpectedOutcome(response);

				}else{
					successCallback(response);
				}
			}
		});
	};
	
	cip_Common.handleUnexpectedOutcome = function (response) {
		if(response.unexpectedOutcome === "APPLICANT_SMS_CODE_AUTHENTICATION_REQUIRED"){
			cip_Entity.showSendSmsCodeDialog(cip_Common.brandId, cip_Common.formId, response.data, function(){
				cc_EntityIntegration.sendApplicantSessionActivationSmsCode(function(){
					cip_Entity.showActivateUsingSmsCodeDialog(cip_Common.brandId, cip_Common.formId, response.data);
				});
			});
			
		}else if(response.unexpectedOutcome === "APPLICANT_CUSTOMER_DETAILS_AUTHENTICATION_REQUIRED"){
			cip_Entity.showActivateUsingCustomerDetailsDialog(cip_Common.brandId, cip_Common.formId, response.data);
			
		}else if(response.unexpectedOutcome === "INVALID_APPLICANT_SMS_CODE"){
			cip_Entity.handleInvalidApplicantSmsCode(cip_Common.brandId, cip_Common.formId, response.data);
			
		}else if(response.unexpectedOutcome === "INVALID_APPLICANT_CUSTOMER_DETAILS"){
			cip_Entity.handleInvalidApplicantCustomerDetails(cip_Common.brandId, cip_Common.formId, response.data);
			
		}else if(response.unexpectedOutcome === "INACTIVE_APPLICANT_SESSION_USING_SMS_CODE"){
			cip_Entity.showActivateUsingSmsCodeDialog(cip_Common.brandId, cip_Common.formId, response.data);
			
		}else if(response.unexpectedOutcome === "INACTIVE_APPLICANT_SESSION_USING_CUSTOMER_DETAILS"){
			cip_Entity.showActivateUsingCustomerDetailsDialog(cip_Common.brandId, cip_Common.formId, response.data);
			
		}else if(response.unexpectedOutcome === "UNAVAILABLE_APPLICANT_SESSION"){
			cip_Entity.handleUnavailableApplicantSession(cip_Common.brandId, cip_Common.formId);
			
		}
	};
	
	cip_Common.redirectToPage = function(siteId, environment, brandId, formId, page, applicantAccessKey, applicationId){
		var url =  cc_Util.getRelativePath();
		
		if(siteId && environment && brandId && formId){
			url += siteId + '/' + environment + '/' + brandId + '/' + formId + '/';
			
			if(page){
				url += page + '.html';	
				
				if(applicationId && applicantAccessKey){
					url += '?a=' + applicationId + '&s=' + applicantAccessKey;
				}
			}
		}
		
		// is redirecting to self
		if(page && cc_UI.getCurrentPage() == page + '.html'){
			// use this method of redirection so that the previous requested url is not added
			// to the browser history. this way the back button will not include it.
			// this is especially important when application.html is used to start a new application
			// and no application id is supplied
			window.location.replace(url);
			
		}else{
			window.location.href = url;
		}
	};
	
	cip_Common.redirectToStatusPageFromApplicationPage = function(currentFormId){
		window.location.href = window.location.href.replace("/" + currentFormId + "/application", "/status");
	};
	
	cip_Common.redirectToApplicationPageFromStatusPage = function(currentFormId, applicationId){
		window.location.href = cip_Common.toApplicationPageFromStatusPageUrl(currentFormId, applicationId);
	};
	
	cip_Common.redirectToAnotherFormPage = function(currentFormId, newFormId){
		return window.location.href.replace(window.location.search,'').replace('/' + currentFormId, '/' + newFormId);
	};
	
	cip_Common.toApplicationPageFromStatusPageUrl = function (currentFormId, applicationId) {
		return window.location.href.replace("/status.html?", "/" + currentFormId + "/application.html?a=" + applicationId + "&")
	};
	
	cip_Common.toApplicationFormUrl = function (formId) {
		return cip_Common.toApplicationUrl() + '/' + formId;
	};
	
	cip_Common.toApplicationUrl = function () {
		return cip_Common.toBrandUrl('application');
	};
	
	cip_Common.toStatusUrl = function () {
		return cip_Common.toBrandUrl('status');
	};
	
	cip_Common.toAuthenticationUrl = function () {
		return cip_Common.toRootUrl() + '/authentication/' + cip_Common.siteId + '/' + cip_Common.environment + '/' + 
				cip_Common.brandId;
	};
	
	cip_Common.toBrandUrl = function (controller) {
		return cip_Common.toRootUrl() + '/' + controller + '/' + cip_Common.siteId + '/' + cip_Common.environment + '/' + 
				cip_Common.brandId + (cip_Common.applicantAccessKey != null ? '/' + cip_Common.applicantAccessKey : '');
	};
	
	cip_Common.toRootUrl = function (controller) {
		return cc_Util.getRelativePath() + 'json';
	};
		
	cip_Common.getContextPath = function(){
		return window.location.pathname.split('/')[1];
	};	
	
	cip_Common.isUsingHttps = function(){
		return window.location.protocol === 'https:';
	};
	
	$(window).on("load", function () {		
		$.doTimeout(cip_Common.keepAliveInterval, function(){
			$.ajax({ 
				url: cip_Common.toRootUrl() + '/keepalive',
				type: 'GET',
				error: {}, // don't handle errors 
				throbber : false
			}); 
			// poll
			return true;
		});
	});
	
}());